import type { EvaluationReview } from '@shared/domain/review';
import React from 'react';
import { ReviewStep } from '@shared/domain/review';
import { EVALUATION_FORM_FIELDS } from '../../data';
import { BaseReviewForm } from '../BaseReviewForm';

interface EvaluationReviewProps {
  submitReviewForm?: (
    formFields: EvaluationReview,
    reviewStep: ReviewStep,
    isDraft?: boolean,
  ) => void;
  editMode?: boolean;
  defaultValues?: Partial<EvaluationReview> & { id?: number };
  handleEditSuccess?: () => void;
}

function EvaluationReviewForm(props: EvaluationReviewProps) {
  return (
    <BaseReviewForm<EvaluationReview>
      reviewStep={ReviewStep.EVALUATION}
      formFields={EVALUATION_FORM_FIELDS}
      containerTestId="evaluation-review-step-content-anchor"
      submitButtonText="Continue to Legal"
      editMode={props.editMode}
      defaultValues={props.defaultValues}
      onSubmit={props.submitReviewForm}
      onEditSuccess={props.handleEditSuccess}
    />
  );
};

export default EvaluationReviewForm;
